import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import {
  ContentContainer,
  MobileWrapper,
  DesktopWrapper,
} from 'features/components/ProductDetailHero/ProductDetailHero.styles'
import { StaticImageData } from 'next/image'
import Link from 'next/link'
import { Stack } from 'components/Stack'
import { HeroImage } from 'features/components/ProductDetailHero/components/HeroImage'
import { ProductFeatures } from 'features/components/ProductDetailHero/components/ProductFeatures'
import { HeroHeader } from 'features/components/ProductDetailHero/components/HeroHeader'
import { InformationCollapse, InformationCollapseType } from 'features/components/ProductDetailHero/components/InformationCollapse'
import { ProductDetailHero } from 'features/components/ProductDetailHero'
import { Button } from 'components/Button'
import { Proteins } from 'models/Pet'

type HeroProps = {
  recipe: Proteins
  thumbnail: StaticImageData
}

export const RecipeDetailHero = ({ recipe, thumbnail }: HeroProps) => {
  const { t } = useTranslation()

  const infoList: InformationCollapseType[] = [
    {
      label: `recipes:${recipe}.hero.ingredients.label`,
      description: `recipes:${recipe}.hero.ingredients.description`,
    },
    {
      label: `recipes:${recipe}.hero.nutrition.label`,
      description: `recipes:${recipe}.hero.nutrition.description`,
    },
    {
      label: 'recipes:individual.hero.safety.label',
      description: 'recipes:individual.hero.safety.description',
    },
    {
      label: 'recipes:individual.hero.first.label',
      description: 'recipes:individual.hero.first.description',
    },
  ]

  return (
    <ProductDetailHero recipe={recipe}>
      <MobileWrapper>
        <ProductFeatures recipe={recipe} />
        <InformationCollapse infoList={infoList} />
      </MobileWrapper>
      <HeroImage thumbnail={thumbnail} alt={t(`recipes:${recipe}.hero.img`)} />
      <ContentContainer padding>
        <Stack
          display="flex"
          direction="column"
          alignItems="center"
          justifyContent="flex-start"
          gap={{ '@initial': '3', '@bp3': '7' }}
        >
          <HeroHeader
            title={t(`recipes:${recipe}.hero.title`)}
            subtitle={t(`recipes:${recipe}.hero.subtitle`)}
          />
          <DesktopWrapper>
            <ProductFeatures recipe={recipe} />
          </DesktopWrapper>
          <Link href="/meal-plan">
            <Button>{t(`recipes:${recipe}.cta-1`)}</Button>
          </Link>
        </Stack>
        <DesktopWrapper>
          <InformationCollapse infoList={infoList} />
        </DesktopWrapper>
      </ContentContainer>
    </ProductDetailHero>
  )
}

RecipeDetailHero.displayName = 'RecipeDetailHero'
